import { render, staticRenderFns } from "./FreePerksCategoriesCards.vue?vue&type=template&id=be974b84&scoped=true&"
import script from "./FreePerksCategoriesCards.vue?vue&type=script&lang=js&"
export * from "./FreePerksCategoriesCards.vue?vue&type=script&lang=js&"
import style0 from "./FreePerksCategoriesCards.vue?vue&type=style&index=0&id=be974b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be974b84",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BCardGroup} from 'bootstrap-vue'
    installComponents(component, {BCard, BCardGroup})
    

export default component.exports